module.exports = __webpack_public_path__ + "img/vip4.2c41e51b.png";